var map = {
	"./advantage_1_bg.png": "2536",
	"./advantage_1_bg_big.png": "78b2",
	"./advantage_2_bg.png": "068b",
	"./advantage_2_bg_big.png": "bc31",
	"./advantage_3_bg.png": "3e6b",
	"./advantage_3_bg_big.png": "5d50",
	"./advantage_4_bg.png": "e30c",
	"./advantage_4_bg_big.png": "ff6a",
	"./advantage_5_bg.png": "c481",
	"./advantage_5_bg_big.png": "b6e1",
	"./arraw_left.png": "da11",
	"./arraw_right.png": "8817",
	"./computer.png": "d30d",
	"./cooperate_1.png": "f5b0",
	"./cooperate_2.png": "6e85",
	"./home-part2-bg.png": "2265",
	"./home-video4-cover.png": "9576",
	"./honer_2.png": "3ac4",
	"./honer_3.png": "543c",
	"./honer_bg.jpg": "5c2c",
	"./honer_video_cover.png": "6f44",
	"./index_banner1.png": "5405",
	"./play.png": "4c5f",
	"./six-angle.png": "17a4",
	"./structure.png": "b5aa",
	"./system_1.png": "0774",
	"./system_10.png": "d5b7",
	"./system_2.png": "4923",
	"./system_3.png": "9f28",
	"./system_4.png": "fe55",
	"./system_5.png": "70eb",
	"./system_6.png": "93e5",
	"./system_7.png": "38ee",
	"./system_8.png": "356d",
	"./system_9.png": "fc71",
	"./system_bg.png": "bced",
	"./video_cover.png": "2f48"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ede";